// Thwip web-shot sound synthesized via Web Audio API.
// No external asset needed. Very short (~180ms), quiet by default.

const STORAGE_KEY = "ledgerly-sound";

export const isSoundEnabled = () => {
  try { return localStorage.getItem(STORAGE_KEY) === "on"; }
  catch { return false; }
};

export const setSoundEnabled = (on) => {
  try { localStorage.setItem(STORAGE_KEY, on ? "on" : "off"); } catch (e) { /* ignore */ }
};

let ctxSingleton = null;
const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctxSingleton) ctxSingleton = new AC();
  if (ctxSingleton.state === "suspended") ctxSingleton.resume().catch(() => {});
  return ctxSingleton;
};

export const playThwip = () => {
  if (!isSoundEnabled()) return;
  const ctx = getCtx();
  if (!ctx) return;
  const now = ctx.currentTime;

  // Master gain envelope
  const master = ctx.createGain();
  master.gain.setValueAtTime(0.0, now);
  master.gain.linearRampToValueAtTime(0.18, now + 0.01);
  master.gain.exponentialRampToValueAtTime(0.0001, now + 0.18);
  master.connect(ctx.destination);

  // Downward pitch sweep — the "thwip" arc
  const osc = ctx.createOscillator();
  osc.type = "sawtooth";
  osc.frequency.setValueAtTime(1800, now);
  osc.frequency.exponentialRampToValueAtTime(260, now + 0.15);
  const oscGain = ctx.createGain();
  oscGain.gain.setValueAtTime(0.6, now);
  oscGain.gain.exponentialRampToValueAtTime(0.001, now + 0.16);
  osc.connect(oscGain).connect(master);
  osc.start(now);
  osc.stop(now + 0.18);

  // Short noise burst — the "shhht" tail
  const bufferSize = Math.floor(ctx.sampleRate * 0.09);
  const noiseBuf = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
  const data = noiseBuf.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / bufferSize);
  const noise = ctx.createBufferSource();
  noise.buffer = noiseBuf;
  const hp = ctx.createBiquadFilter();
  hp.type = "highpass";
  hp.frequency.value = 1600;
  const noiseGain = ctx.createGain();
  noiseGain.gain.setValueAtTime(0.35, now + 0.02);
  noiseGain.gain.exponentialRampToValueAtTime(0.001, now + 0.12);
  noise.connect(hp).connect(noiseGain).connect(master);
  noise.start(now + 0.02);
  noise.stop(now + 0.12);
};
